// Import necessary modules
import nav from './ui.nav';
import tabs from './ui.tabs';
import dynamicNav from './ui.dynamic-nav';
import accordions from './ui.accordions';
import links from './ui.links';

/**
 * Initialises the UI
 */
export default () => {
	nav();
	tabs();
	dynamicNav();
	accordions();
	links();
};
